(function () {
    'use strict';

    angular
        .module('app.admin')
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('home.adminUserManagement', {
                    requireLogin: true,
                    url: 'admin/userManagement',
                    templateUrl: 'app/admin/userAndBilling/userManagement/userManagement.html?app_v=deployDate',
                    data: {
                        authorizedRoles: ['Administrator'],
                        navMarker: ['admin', 'userManagement']
                    },
                    params: {
                        data: null
                    },
                    controller: 'userManagementCtrl'
                })
        }]);
})();